import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import GspAnimate from "../modules/GspAnimate";
import ImageParallax from '../modules/ImageParallax';
gsap.registerPlugin(ScrollTrigger,ScrollSmoother,ScrollToPlugin);
import Navbar from '../modules/Navbar'

const gspAnimate=new GspAnimate;
const imageparallax=new ImageParallax();
const navbar=new Navbar();
let sectionID=navbar.getSectionId()

let scroller;
function initScrollSmoth(){
	scroller=ScrollSmoother.create({
		smooth: 1,             // how long (in seconds) it takes to "catch up" to the native scroll position
		effects: true,           // looks for data-speed and data-lag attributes on elements
		smoothTouch: 0.1,        // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
	});
}
initScrollSmoth();

////2. Event
window.addEventListener("load", function(){
	gspAnimate.gspFadeUp();
	console.log(sectionID)
	if(sectionID=='overview'){
		navbar.scrollToSection('#overview')
	}
	if(sectionID=='business-details'){
		navbar.scrollToSection('#business-details')
	}
	if(sectionID=='ihs'){
		navbar.scrollToSection('#ihs')
	}
});
window.addEventListener("resize", function(){
	
});

let sectionServiceList = document.querySelector(".service-lists");
let organizationSideTitle = document.querySelector(".service-lists__side-title");
if (sectionServiceList && organizationSideTitle ) {
	ScrollTrigger.create({
		trigger: '.service-lists__side-title',
		start: '-100px top',
		end: () => `+=${ sectionServiceList.offsetHeight - (organizationSideTitle.offsetWidth+100)}`,
		pin: '.service-lists__side-title',
        //markers:true
	})
}

let sectionSRVBusinessContainer = document.querySelector(".service-business");
let SRVBusinessTitle = document.querySelector(".service-business__side-title");
if (sectionSRVBusinessContainer && SRVBusinessTitle ) {
	ScrollTrigger.create({
		trigger: SRVBusinessTitle,
		start: '-100px top',
		end: () => `+=${ sectionSRVBusinessContainer.offsetHeight - (SRVBusinessTitle.offsetWidth+390)}`,
		pin: SRVBusinessTitle,
        //markers:true
	})
}

let sectionServiceIHS = document.querySelector(".service-IHS");
let serviceIHSSideTitle = document.querySelector(".service-IHS__side-title");
if (sectionServiceIHS && serviceIHSSideTitle ) {
	ScrollTrigger.create({
		trigger: serviceIHSSideTitle ,
		start: '-50px top',
		end: () => `+=${ sectionServiceIHS.offsetHeight}`,
		pin: serviceIHSSideTitle ,
        //markers:true
	})
}

let sectionBigfish = document.querySelector(".service-bigfish");
let serviceBigfishTitle = document.querySelector(".service-bigfish__side-title");
if (sectionBigfish && serviceBigfishTitle ) {
	ScrollTrigger.create({
		trigger: serviceBigfishTitle ,
		start: '-50px top',
		end: () => `+=${ sectionBigfish.offsetHeight + (SRVBusinessTitle.offsetWidth+400)}`,
		pin: serviceBigfishTitle ,
        //markers:true
	})
}

const sectionsSideTitleRightMobile = gsap.utils.toArray('.section-title__side-right--mobile')
sectionsSideTitleRightMobile.forEach( function(sectionSideTitleRightMobile) {
	gsap.to(sectionSideTitleRightMobile, {
		xPercent: -150,
		ease: "none",
		scrollTrigger: {
			trigger: sectionSideTitleRightMobile,
			start: "top center",
			end: "bottom top",
			scrub: true,
		}
	})
})

const sectionsSideTitleMobile = gsap.utils.toArray('.section-title__side-left--mobile')
sectionsSideTitleMobile.forEach( function(sectionSideTitleMobile) {
	gsap.to(sectionSideTitleMobile, {
		xPercent: -150,
		ease: "none",
		scrollTrigger: {
			trigger: sectionSideTitleMobile,
			start: "top center",
			end: "bottom top",
			scrub: true,
		}
	})
})